"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterBy = exports.compileFilter = void 0;
var utils_1 = require("../utils");
var filter_descriptor_interface_1 = require("./filter-descriptor.interface");
var filter_operators_1 = require("./filter.operators");
var filter_no_eval_1 = require("./filter-no-eval");
// tslint:disable:max-line-length
/**
 * Creates a [Predicate]({% slug api_kendo-data-query_predicate %}) function for the specified [CompositeFilterDescriptor]({% slug api_kendo-data-query_compositefilterdescriptor %}).
 *
 * @param {CompositeFilterDescriptor} descriptor - The descriptor for which the predicate is created.
 * @returns {Predicate} - The created function instance.
 *
 * @example
 * ```ts
 * import { compileFilter } from '@progress/kendo-data-query';
 *
 * const data = [{ name: "Pork" }, { name: "Pepper" }, { name: "Beef" } ];
 * const predicate = compileFilter({ logic: "and", filters: [{ field: "name", operator: "startswith", value: "P" }] });
 * const result = data.filter(predicate);
 *
 * ```
 */
// tslint:enable:max-line-length
var compileFilter = function (descriptor) {
    if (!descriptor || descriptor.filters.length === 0) {
        return function () { return true; };
    }
    return (0, filter_no_eval_1.transformCompositeFilter)(descriptor);
};
exports.compileFilter = compileFilter;
// tslint:disable:max-line-length
/**
 * Filters the provided array according to the specified [CompositeFilterDescriptor]({% slug api_kendo-data-query_compositefilterdescriptor %}).
 *
 * @param {T[]} data - The data that will be filtered.
 * @param {(CompositeFilterDescriptor | FilterDescriptor)} descriptor - The filter criteria that will be applied.
 * @returns {T[]} - The filtered data.
 *
 * @example
 * ```ts
 * import { filterBy } from '@progress/kendo-data-query';
 *
 * const data = [
 *  { name: "Pork", category: "Food", subcategory: "Meat" },
 *  { name: "Pepper", category: "Food", subcategory: "Vegetables" },
 *  { name: "Beef", category: "Food", subcategory: "Meat" }
 * ];
 *
 * const result = filterBy(data, {
 *     logic: 'and',
 *     filters: [
 *           { field: "name", operator: "startswith", value: "p", ignoreCase: true },
 *           { field: "subcategory", operator: "eq", value: "Meat" },
 *     ]
 * });
 *
 * // output:
 * // [{ "name": "Pork", "category": "Food", "subcategory": "Meat" }]
 * ```
 */
// tslint:enable:max-line-length
var filterBy = function (data, descriptor) {
    if (!(0, utils_1.isPresent)(descriptor) || ((0, filter_descriptor_interface_1.isCompositeFilterDescriptor)(descriptor) && descriptor.filters.length === 0)) {
        return data;
    }
    return data.filter((0, exports.compileFilter)((0, filter_operators_1.normalizeFilters)(descriptor)));
};
exports.filterBy = filterBy;



//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-data-query@1.7.1/~/@progress/kendo-data-query/dist/npm/filtering/filter-expression.factory.js
// module id = 155
// module chunks = 0